/* @flow */

import classNames from 'classnames';
import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

import styles from './AuthenticationPasswordToggle.style';
import messages from 'src/shared/app/authentication/l10n/authenticationL10n';

type Props = {
  layoutClass?: string,
  isPasswordVisible: boolean,
  handleToggle: () => void,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const useStyles = createUseStyles(styles);

const AuthenticationPasswordToggle = ({
  isPasswordVisible,
  handleToggle,
  layoutClass,
  intl,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Event Handlers
   |----------------------------------------------------------------------------
   */

  const onToggle = (e: MouseEvent) => {
    e.preventDefault();

    handleToggle();
  };

  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  const rootClasses = classNames(layoutClass, classes.root);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <a className={rootClasses} href="#" onClick={onToggle}>
      {intl.formatMessage(messages.passwordToggle, {
        isVisible: isPasswordVisible,
      })}
    </a>
  );
};

export default compose(React.memo, injectIntl)(AuthenticationPasswordToggle);
